import React from 'react';
import 'styles/settings/fonts.css';
import 'styles/styles.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainHeader from 'components/ui/header';
import PreloadPage from 'pages/preload';
import PTGPage from 'pages/affiliates/ptg';
import BlogPage from 'pages/blog';
import AlliancesPage from 'pages/alliances';
import SinglePage from 'pages/single';
import HarborPage from 'pages/affiliates/harbor';
import PTYSSPage from 'pages/affiliates/ptyss';
import ESGPage from 'pages/esg';
import ContactModal from 'components/generals/modal/contact';
import MenuMovil from 'components/generals/menu-movil';
import MainFooter from 'components/ui/footer';
import AlliancesMenu from 'components/generals/aliances-menu';
import { useLocation } from 'react-router-dom';

import 'animate.css';
import './i18n';
function App() {
    const { pathname } = useLocation();
    console.log(pathname);
    return (
        <>
            <MainHeader />
            <Routes>
                <Route path="/" element={<PreloadPage />} />
                <Route path="/ptg" element={<PTGPage />} />
                <Route path="/harbour" element={<HarborPage />} />
                <Route path="/ptyss" element={<PTYSSPage />} />
                <Route path="/alliances" element={<AlliancesPage />} />
                <Route path="/esg" element={<ESGPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/post/:slug" element={<SinglePage />} />
            </Routes>
            <MenuMovil />
            {/* <AlliancesMenu /> */}
            <ContactModal />
        </>
    );
}

export default App;
